import React, { ReactNode } from 'react';
import { Bowtie } from './bowtie';
import { BowtieDisplayMode } from './external-types';

import styles from './bowtie-search-result.scss';

export const BowtieSearchResult: React.FC<React.PropsWithChildren<{ caseNumber: number; footer?: ReactNode }>> =
  ({ caseNumber, footer }) => {
    return <div className={styles.searchResult} style={{ height: 600 }}>
      <Bowtie
        key={caseNumber}
        caseNumber={caseNumber}
        displayMode={BowtieDisplayMode.searchResult}
        footer={footer} />
    </div>;
  };
